// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 
    Default styles for jsPlumb Toolkit

    Copyright 2020 https://jsplumbtoolkit.com
*/

/* --------------------------------------------------------------------------------------------- */
/* --- SURFACE WIDGET -------------------------------------------------------------------------- */
/* --------------------------------------------------------------------------------------------- */

/*
    Assigned to SVG elements for edges. This style allows overlays to paint outside the bounds, and
    for arbitrary stroke widths for connectors.
 */
.jtk-connector {
    overflow:visible;
}

/*
    Assigned to every Node managed by an instance of the Toolkit. They are required to be positioned absolute, to
    enable dragging to work properly.
*/
.jtk-node {
    position: absolute;
}

/*
    Assigned to every Group managed by an instance of the Toolkit. They are required to be positioned absolute, to
    enable dragging to work properly. We set overflow:visible on Group elements too, as a drag outside of the bounds
    is automatically reverted anyway, and without overflow:visible you cannot drag a node to some other element. You can
    also drag a node out of the element's viewport and if you drop it you can never get it back.
*/
.jtk-group {
    position: absolute;
    overflow: visible;
}

/*

    This is the attribute used to mark which part of a Group DOM element should contain the child Nodes. We mark it
    as having \`position:relative\` so that the absolute positioned Nodes are drawn correctly.
*/
[jtk-group-content] {
    position:relative;
}

/*
    This style was created in response to this Chrome bug:
    http://stackoverflow.com/questions/13758215/artifacts-when-css-scaled-in-chrome

    Basically it's about how sometimes there can be artefacts left on screen when the user drags an element. It seems
    the issue has been fixed in more recent versions of Chrome, but the style is left here in case you come across
    the problem.
*/
.jtk-node.jtk-drag {
    /*-webkit-backface-visibility: hidden;*/
}

/*
    Suppresses the pointer events on an element that was created by Katavorio in response to a drag in which the element
    should first be cloned. Having this clone ignore pointer events means there is less chance that any other
    mouse activity (such as click) on the original element will not be consumed by katavorio.
 */
.katavorio-clone-drag {
    pointer-events:none;
}

/*
    Assigned to an element that is the \`Container\` in a \`render\` call.
    Elements that are acting as Surface widgets should have overflow:hidden set to prevent libs from
    scrolling them during drag (we don't want scrollbars; we have an infinite canvas). Position is set to
    \`relative\` as this is the parent for nodes, which are positioned absolute (and for absolute positioning
    to work, you need to ensure the parent node has \`position:relative\`). This style also sets some default
    values for the cursor - using a \`grab\` cursor where supported.
*/
.jtk-surface {
    overflow: hidden !important;
    position: relative;
    cursor: move;
    cursor: -webkit-grab;

    /*
        For IE10+. As discussed on this page:

        https://msdn.microsoft.com/en-us/library/ie/jj583807(v=vs.85).aspx

        Microsoft have very helpfully implemented default behaviours for a bunch of touch events and
        then consumed the events so you don't have to be bothered by them. They've "done a lot of research"
        about this stuff and put together a really great default experience for everyone in the entire world.
    */
    touch-action:none;

    /*
        Another Chrome issue that appears to have been fixed in later versions
        http://stackoverflow.com/questions/15464055/css-transition-effect-makes-image-blurry-moves-image-1px-in-chrome
    */
    /*
    -webkit-backface-visibility: hidden;
    -webkit-transform: translateZ(0) scale(1.0, 1.0);
    */
}

/**
* Assigned to a Surface element when direct rendering is switched on - no pan or zoom, the underlying canvas scaled to fit its contents at zoom:1.
 */
.jtk-surface-direct-render {
    overflow:hidden !important;
}

/*
    Assigned to the surface when it is being panned. The default is to change the cursor (in browsers that support
    a \`grabbing\` cursor), and to disable text selection.
*/
.jtk-surface-panning {
    cursor: -webkit-grabbing;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    user-select: none;
}

/*
    The work area in a surface renderer.
*/
.jtk-surface-canvas {
    overflow: visible !important;
}

/*
    For IE10+. Discussed above in the .jtk-surface styles. This one is specific to elements that are configured
    to be droppable on a Surface via its \`registerDroppableNodes\` method.
*/
.jtk-surface-droppable-node {
    touch-action:none;
}

/*
    Assigned to a Surface widget when panning is disabled (and therefore the app is relying on scrollbars when the content overflows).
*/
.jtk-surface-nopan {
    overflow: scroll !important;
    cursor:default;
}

/*
Assigned to tile images in a tiled background
*/
.jtk-surface-tile {
    border:none;
    outline:none;
    margin:0;
    transition: opacity .3s ease .15s;
}

/*
    Assigned to the element used for node select with the mouse ("lasso").
*/
.jtk-lasso {
    border: 2px solid rgb(49, 119, 184);
    background-color: WhiteSmoke;
    opacity: 0.5;
    display: none;
    z-index: 20000;
    position: absolute;
}

/*
    This class is added to the document body on lasso drag start and removed at the end of lasso dragging. Its purpose
    is to switch off text selection on all elements while the user is dragging the lasso.
*/
.jtk-lasso-select-defeat * {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    user-select: none;
}

/**
    Added to the lasso mask when it is operating in 'inverted' mode, ie. the excluded parts of the UI are covered, rather
    than the normal mode in which the selected parts of the UI are covered.
*/
.jtk-lasso-mask {
    position:fixed;
    z-index:20000;
    display:none;
    opacity:0.5;
    background-color: #07234E;
    top:0;
    bottom:0;
    left:0;
    right:0;
}

/*
    Assigned to some element that has been selected (either via lasso or programmatically).
*/
.jtk-surface-selected-element {
    border: 2px dotted #c7726c !important;
}

/*
    Assigned to all pan buttons in a surface widget.
*/
.jtk-surface-pan {
    background-color: Azure;
    opacity: 0.4;
    text-align: center;
    cursor: pointer;
    z-index: 2;
    transition: background-color 0.15s ease-in;
}

/*
    Specific styles for the top and bottom pan buttons.
    Top/bottom are 100% width and 20px high by default
*/
.jtk-surface-pan-top, .jtk-surface-pan-bottom {
    width: 100%;
    height: 20px;
}

/*
    Hover styles for all pan buttons.
    On hover, change color, background color, font weight and opacity.
*/
.jtk-surface-pan-top:hover, .jtk-surface-pan-bottom:hover, .jtk-surface-pan-left:hover, .jtk-surface-pan-right:hover {
    opacity: 0.6;
    background-color: rgb(49, 119, 184);
    color: white;
    font-weight: bold;
}

/*
    Specific styles for the left and right pan buttons.
    Left/right pan buttons are 100% height and 20px wide
*/
.jtk-surface-pan-left, .jtk-surface-pan-right {
    width: 20px;
    height: 100%;
    line-height: 40;
}


/*
    Assigned to a pan button when the user is pressing it.
*/
.jtk-surface-pan-active, .jtk-surface-pan-active:hover {
    background-color: #f76258;
}

/* --------------------------------------------------------------------------------------------- */
/* --- MINIVIEW WIDGET ------------------------------------------------------------------------- */
/* --------------------------------------------------------------------------------------------- */

/*
    Assigned to an element that is acting as a Miniview.
    As with Surface, Miniview elements should have overflow:hidden set to prevent
    libs from scrolling them during drag. This style also provides a default width/height for a miniview,
    which you may wish to override.
*/
.jtk-miniview {
    overflow: hidden !important;
    width: 125px;
    height: 125px;
    position: relative;
    background-color: transparent;
    border: 2px solid #d4d8dc;
    border-radius: 4px;
    opacity: 0.8;
}

/* 
    Assigned to the element that shows the size of the related viewport in a Miniview widget, and which can be dragged to
    move the surface.
*/
.jtk-miniview-panner {
    border: 5px dotted WhiteSmoke;
    opacity: 0.4;
    background-color: rgb(79, 111, 126);
    cursor: move;
    cursor: -webkit-grab;
}

/*
    Assigned to the miniview's panner when it is being dragged.
*/
.jtk-miniview-panning {
    cursor: -webkit-grabbing;
}

/*
    Added to all elements displayed in a miniview.
*/
.jtk-miniview-element {
    background-color: rgb(96, 122, 134);
    position: absolute;
}

/*
    Added to Group elements displayed in a miniview
*/
.jtk-miniview-group-element {
    background: transparent;
    border: 2px solid rgb(96,122,134);
}

/*
    Assigned to the collapse/expand miniview button
*/
.jtk-miniview-collapse {
    color: whiteSmoke;
    position: absolute;
    font-size: 18px;
    top: -1px;
    right: 3px;
    cursor: pointer;
    font-weight: bold;
}

/*
    The '-' symbol when the miniview is expanded
*/
.jtk-miniview-collapse:before {
    content: "\\2012";
}

/*
    Assigned to the miniview element when it is collapsed.
*/
.jtk-miniview-collapsed {
    background-color: #449ea6;
    border-radius: 4px;
    height: 22px;
    margin-right: 0;
    padding: 4px;
    width: 21px;
}

/*
    Hide all children of the miniview (except the expand button) when it is collapsed so you don't see anything
    poking through under the + icon.
*/
.jtk-miniview-collapsed .jtk-miniview-element, .jtk-miniview-collapsed .jtk-miniview-panner {
    visibility: hidden;
}

/*
    The '+' symbol when the miniview is collapsed.
*/
.jtk-miniview-collapsed .jtk-miniview-collapse:before {
    content: "+";
}

/*
    Hover state for the collapse/expand icon.
*/
.jtk-miniview-collapse:hover {
    color: #E4F013;
}

/* ------------------------------------------------------------------------------------------- */
/* --- DIALOGS --------------------------------------------------------------------------------*/
/* ------------------------------------------------------------------------------------------- */

/*
    This is the element that acts as the dialog underlay - the modal "mask". Note the high z-index default
    set here (and note also the overlay style below has a z-index with a value higher by one).
*/
.jtk-dialog-underlay {
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    position: fixed;
    z-index: 100000;
    opacity: 0.8;
    background-color: #CCC;
    display: none;
}

/*
    This is the element that acts as the parent for dialog content.
*/
.jtk-dialog-overlay {
    position: fixed;
    z-index: 100001;
    display: none;
    background-color: white;
    font-family: "Open Sans", sans-serif;
    padding: 9px;
    box-shadow: 0 0 5px grey;
    overflow: hidden;
    border-radius: 3px;
}

.jtk-dialog-overlay-x {
    max-height:0;
    transition: max-height 0.5s ease-in;
    -moz-transition: max-height 0.5s ease-in;
    -ms-transition: max-height 0.5s ease-in;
    -o-transition: max-height 0.5s ease-in;
    -webkit-transition: max-height 0.5s ease-in;
}

.jtk-dialog-overlay-y {
    max-width:0;
    transition: max-width 0.5s ease-in;
    -moz-transition: max-width 0.5s ease-in;
    -ms-transition: max-width 0.5s ease-in;
    -o-transition: max-width 0.5s ease-in;
    -webkit-transition: max-width 0.5s ease-in;
}

.jtk-dialog-overlay-top {
    top:20px;
}

.jtk-dialog-overlay-bottom {
    bottom:20px;
}

.jtk-dialog-overlay-left {
    left:20px;
}

.jtk-dialog-overlay-right {
    right:20px;
}

.jtk-dialog-overlay-x.jtk-dialog-overlay-visible {
    max-height:1000px;
}

.jtk-dialog-overlay-y.jtk-dialog-overlay-visible {
    max-width:1000px;
}

/*
    The element containing buttons in a dialog.
*/
.jtk-dialog-buttons {
    text-align: right;
    margin-top: 7px;
}

/*
    An individual button in a dialog.
*/
.jtk-dialog-button {
    cursor: pointer;
    margin-right: 5px;
    min-width: 56px;
    background-color: white;
    border: 1px solid #ccc;
    border-radius: 3px;
    padding: 4px;
    outline: none;
}

/*
    Hover style for an individual button in a dialog.
*/
.jtk-dialog-button:hover {
    color: white;
    background-color: #5184a0;
    border-color:white;
}

/*
    The titlebar of a dialog.
*/
.jtk-dialog-title {
    text-align: left;
    font-size: 14px;
    margin-bottom: 9px;
}

.jtk-dialog-content {
    font-size:12px;
    text-align:left;
    min-width:250px;
    margin: 0 14px;
}

.jtk-dialog-content ul {
    width:100%;
    padding-left:0;
}

.jtk-dialog-content label {
    cursor: pointer;
    font-weight: inherit;
}

.jtk-dialog-overlay input, .jtk-dialog-overlay textarea {
    background-color: #FFF;
    border: 1px solid #CCC;
    color: #333;
    font-size: 14px;
    font-style: normal;
    outline: none;
    padding: 6px 4px;
    margin-right: 6px;
}

.jtk-dialog-overlay input:focus, .jtk-dialog-overlay textarea:focus {
    background-color: #f1f5fb;
    border: 1px solid #5184a0;
    color: #333;
    font-size: 14px;
    font-style: normal;
    outline: none;
}

/* -------------------------------------------------------------------------------------------- */
/* --- DRAWING TOOLS -------------------------------------------------------------------------- */
/* -------------------------------------------------------------------------------------------- */

/*
    Assigned to the element that is drawn around some other element when a drawing operation is taking place.
*/
.jtk-draw-skeleton {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    outline: 2px solid #84acb3;
    opacity: 0.8;
}

/*
    Assigned to every handle (top left, top right, bottom left, bottom right, center) in a draw skeleton.
*/
.jtk-draw-handle {
    position: absolute;
    width: 7px;
    height: 7px;
    background-color: #84acb3;
}

/*
    Assigned to the top left handle in a draw skeleton
*/
.jtk-draw-handle-tl {
    left: 0;
    top: 0;
    cursor: nw-resize;
}

/*
    Assigned to the top right handle in a draw skeleton
*/
.jtk-draw-handle-tr {
    right: 0;
    top: 0;
    cursor: ne-resize;
}

/*
    Assigned to the bottom left handle in a draw skeleton
*/
.jtk-draw-handle-bl {
    left: 0;
    bottom: 0;
    cursor: sw-resize;
}

/*
    Assigned to the bottom right handle in a draw skeleton
*/
.jtk-draw-handle-br {
    bottom: 0;
    right: 0;
    cursor: se-resize;
}

/*
    Assigned to the center handle in a draw skeleton (the handle by which the element may be dragged). This is
    not visible by defaut; enable if you need it.
*/
.jtk-draw-drag {
    display:none;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -10px;
    margin-top: -10px;
    width: 20px;
    height: 20px;
    background-color: #84acb3;
    cursor: move;
}

/*
    This class is added to the document body on drag resize start and removed at the end of resizing. Its purpose
    is to switch off text selection on all elements while the user is resizing an element.
*/
.jtk-drag-select-defeat * {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    user-select: none;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/jsplumbtoolkit.css"],"names":[],"mappings":"AAAA;;;;CAIC;;AAED,kGAAkG;AAClG,kGAAkG;AAClG,kGAAkG;;AAElG;;;EAGE;AACF;IACI,gBAAgB;AACpB;;AAEA;;;CAGC;AACD;IACI,kBAAkB;AACtB;;AAEA;;;;;CAKC;AACD;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;;;;CAIC;AACD;IACI,iBAAiB;AACrB;;AAEA;;;;;;;CAOC;AACD;IACI,uCAAuC;AAC3C;;AAEA;;;;EAIE;AACF;IACI,mBAAmB;AACvB;;AAEA;;;;;;;CAOC;AACD;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,YAAY;IAEZ,oBAAoB;;IAEpB;;;;;;;;KAQC;IACD,iBAAiB;;IAEjB;;;KAGC;IACD;;;KAGC;AACL;;AAEA;;EAEE;AACF;IACI,0BAA0B;AAC9B;;AAEA;;;CAGC;AACD;IAEI,wBAAwB;IACxB,2BAA2B;IAC3B,yBAAyB;IAIzB,iBAAiB;AACrB;;AAEA;;CAEC;AACD;IACI,4BAA4B;AAChC;;AAEA;;;CAGC;AACD;IACI,iBAAiB;AACrB;;AAEA;;CAEC;AACD;IACI,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;;CAEC;AACD;IACI,WAAW;IACX,YAAY;IACZ,QAAQ;IAKR,iCAAiC;AACrC;;AAEA;;CAEC;AACD;IACI,mCAAmC;IACnC,4BAA4B;IAC5B,YAAY;IACZ,aAAa;IACb,cAAc;IACd,kBAAkB;AACtB;;AAEA;;;CAGC;AACD;IACI,2BAA2B;IAC3B,yBAAyB;IAIzB,iBAAiB;AACrB;;AAEA;;;CAGC;AACD;IACI,cAAc;IACd,aAAa;IACb,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,KAAK;IACL,QAAQ;IACR,MAAM;IACN,OAAO;AACX;;AAEA;;CAEC;AACD;IACI,qCAAqC;AACzC;;AAEA;;CAEC;AACD;IACI,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,UAAU;IAIV,0CAA0C;AAC9C;;AAEA;;;CAGC;AACD;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;;;CAGC;AACD;IACI,YAAY;IACZ,mCAAmC;IACnC,YAAY;IACZ,iBAAiB;AACrB;;AAEA;;;CAGC;AACD;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;;AAGA;;CAEC;AACD;IACI,yBAAyB;AAC7B;;AAEA,kGAAkG;AAClG,kGAAkG;AAClG,kGAAkG;;AAElG;;;;;CAKC;AACD;IACI,2BAA2B;IAC3B,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,6BAA6B;IAC7B,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;;;CAGC;AACD;IACI,6BAA6B;IAC7B,YAAY;IACZ,mCAAmC;IACnC,YAAY;IAEZ,oBAAoB;AACxB;;AAEA;;CAEC;AACD;IAEI,wBAAwB;AAC5B;;AAEA;;CAEC;AACD;IACI,mCAAmC;IACnC,kBAAkB;AACtB;;AAEA;;CAEC;AACD;IACI,uBAAuB;IACvB,iCAAiC;AACrC;;AAEA;;CAEC;AACD;IACI,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,SAAS;IACT,UAAU;IACV,eAAe;IACf,iBAAiB;AACrB;;AAEA;;CAEC;AACD;IACI,gBAAgB;AACpB;;AAEA;;CAEC;AACD;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,WAAW;AACf;;AAEA;;;CAGC;AACD;IACI,kBAAkB;AACtB;;AAEA;;CAEC;AACD;IACI,YAAY;AAChB;;AAEA;;CAEC;AACD;IACI,cAAc;AAClB;;AAEA,gGAAgG;AAChG,gGAAgG;AAChG,gGAAgG;;AAEhG;;;CAGC;AACD;IACI,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,eAAe;IACf,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,aAAa;AACjB;;AAEA;;CAEC;AACD;IACI,eAAe;IACf,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,oCAAoC;IACpC,YAAY;IACZ,wBAAwB;IACxB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,mCAAmC;IACnC,wCAAwC;IACxC,uCAAuC;IACvC,sCAAsC;IACtC,2CAA2C;AAC/C;;AAEA;IACI,WAAW;IACX,kCAAkC;IAClC,uCAAuC;IACvC,sCAAsC;IACtC,qCAAqC;IACrC,0CAA0C;AAC9C;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;CAEC;AACD;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;;CAEC;AACD;IACI,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,aAAa;AACjB;;AAEA;;CAEC;AACD;IACI,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;;CAEC;AACD;IACI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,aAAa;AACjB;;AAEA,iGAAiG;AACjG,iGAAiG;AACjG,iGAAiG;;AAEjG;;CAEC;AACD;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,0BAA0B;IAC1B,YAAY;AAChB;;AAEA;;CAEC;AACD;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,yBAAyB;AAC7B;;AAEA;;CAEC;AACD;IACI,OAAO;IACP,MAAM;IACN,iBAAiB;AACrB;;AAEA;;CAEC;AACD;IACI,QAAQ;IACR,MAAM;IACN,iBAAiB;AACrB;;AAEA;;CAEC;AACD;IACI,OAAO;IACP,SAAS;IACT,iBAAiB;AACrB;;AAEA;;CAEC;AACD;IACI,SAAS;IACT,QAAQ;IACR,iBAAiB;AACrB;;AAEA;;;CAGC;AACD;IACI,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,YAAY;AAChB;;AAEA;;;CAGC;AACD;IACI,2BAA2B;IAC3B,yBAAyB;IAIzB,iBAAiB;AACrB","sourcesContent":["/* \r\n    Default styles for jsPlumb Toolkit\r\n\r\n    Copyright 2020 https://jsplumbtoolkit.com\r\n*/\r\n\r\n/* --------------------------------------------------------------------------------------------- */\r\n/* --- SURFACE WIDGET -------------------------------------------------------------------------- */\r\n/* --------------------------------------------------------------------------------------------- */\r\n\r\n/*\r\n    Assigned to SVG elements for edges. This style allows overlays to paint outside the bounds, and\r\n    for arbitrary stroke widths for connectors.\r\n */\r\n.jtk-connector {\r\n    overflow:visible;\r\n}\r\n\r\n/*\r\n    Assigned to every Node managed by an instance of the Toolkit. They are required to be positioned absolute, to\r\n    enable dragging to work properly.\r\n*/\r\n.jtk-node {\r\n    position: absolute;\r\n}\r\n\r\n/*\r\n    Assigned to every Group managed by an instance of the Toolkit. They are required to be positioned absolute, to\r\n    enable dragging to work properly. We set overflow:visible on Group elements too, as a drag outside of the bounds\r\n    is automatically reverted anyway, and without overflow:visible you cannot drag a node to some other element. You can\r\n    also drag a node out of the element's viewport and if you drop it you can never get it back.\r\n*/\r\n.jtk-group {\r\n    position: absolute;\r\n    overflow: visible;\r\n}\r\n\r\n/*\r\n\r\n    This is the attribute used to mark which part of a Group DOM element should contain the child Nodes. We mark it\r\n    as having `position:relative` so that the absolute positioned Nodes are drawn correctly.\r\n*/\r\n[jtk-group-content] {\r\n    position:relative;\r\n}\r\n\r\n/*\r\n    This style was created in response to this Chrome bug:\r\n    http://stackoverflow.com/questions/13758215/artifacts-when-css-scaled-in-chrome\r\n\r\n    Basically it's about how sometimes there can be artefacts left on screen when the user drags an element. It seems\r\n    the issue has been fixed in more recent versions of Chrome, but the style is left here in case you come across\r\n    the problem.\r\n*/\r\n.jtk-node.jtk-drag {\r\n    /*-webkit-backface-visibility: hidden;*/\r\n}\r\n\r\n/*\r\n    Suppresses the pointer events on an element that was created by Katavorio in response to a drag in which the element\r\n    should first be cloned. Having this clone ignore pointer events means there is less chance that any other\r\n    mouse activity (such as click) on the original element will not be consumed by katavorio.\r\n */\r\n.katavorio-clone-drag {\r\n    pointer-events:none;\r\n}\r\n\r\n/*\r\n    Assigned to an element that is the `Container` in a `render` call.\r\n    Elements that are acting as Surface widgets should have overflow:hidden set to prevent libs from\r\n    scrolling them during drag (we don't want scrollbars; we have an infinite canvas). Position is set to\r\n    `relative` as this is the parent for nodes, which are positioned absolute (and for absolute positioning\r\n    to work, you need to ensure the parent node has `position:relative`). This style also sets some default\r\n    values for the cursor - using a `grab` cursor where supported.\r\n*/\r\n.jtk-surface {\r\n    overflow: hidden !important;\r\n    position: relative;\r\n    cursor: move;\r\n    cursor: -moz-grab;\r\n    cursor: -webkit-grab;\r\n\r\n    /*\r\n        For IE10+. As discussed on this page:\r\n\r\n        https://msdn.microsoft.com/en-us/library/ie/jj583807(v=vs.85).aspx\r\n\r\n        Microsoft have very helpfully implemented default behaviours for a bunch of touch events and\r\n        then consumed the events so you don't have to be bothered by them. They've \"done a lot of research\"\r\n        about this stuff and put together a really great default experience for everyone in the entire world.\r\n    */\r\n    touch-action:none;\r\n\r\n    /*\r\n        Another Chrome issue that appears to have been fixed in later versions\r\n        http://stackoverflow.com/questions/15464055/css-transition-effect-makes-image-blurry-moves-image-1px-in-chrome\r\n    */\r\n    /*\r\n    -webkit-backface-visibility: hidden;\r\n    -webkit-transform: translateZ(0) scale(1.0, 1.0);\r\n    */\r\n}\r\n\r\n/**\r\n* Assigned to a Surface element when direct rendering is switched on - no pan or zoom, the underlying canvas scaled to fit its contents at zoom:1.\r\n */\r\n.jtk-surface-direct-render {\r\n    overflow:hidden !important;\r\n}\r\n\r\n/*\r\n    Assigned to the surface when it is being panned. The default is to change the cursor (in browsers that support\r\n    a `grabbing` cursor), and to disable text selection.\r\n*/\r\n.jtk-surface-panning {\r\n    cursor: -moz-grabbing;\r\n    cursor: -webkit-grabbing;\r\n    -webkit-touch-callout: none;\r\n    -webkit-user-select: none;\r\n    -khtml-user-select: none;\r\n    -moz-user-select: none;\r\n    -ms-user-select: none;\r\n    user-select: none;\r\n}\r\n\r\n/*\r\n    The work area in a surface renderer.\r\n*/\r\n.jtk-surface-canvas {\r\n    overflow: visible !important;\r\n}\r\n\r\n/*\r\n    For IE10+. Discussed above in the .jtk-surface styles. This one is specific to elements that are configured\r\n    to be droppable on a Surface via its `registerDroppableNodes` method.\r\n*/\r\n.jtk-surface-droppable-node {\r\n    touch-action:none;\r\n}\r\n\r\n/*\r\n    Assigned to a Surface widget when panning is disabled (and therefore the app is relying on scrollbars when the content overflows).\r\n*/\r\n.jtk-surface-nopan {\r\n    overflow: scroll !important;\r\n    cursor:default;\r\n}\r\n\r\n/*\r\nAssigned to tile images in a tiled background\r\n*/\r\n.jtk-surface-tile {\r\n    border:none;\r\n    outline:none;\r\n    margin:0;\r\n    -webkit-transition: opacity .3s ease .15s;\r\n    -moz-transition: opacity .3s ease .15s;\r\n    -o-transition: opacity .3s ease .15s;\r\n    -ms-transition: opacity .3s ease .15s;\r\n    transition: opacity .3s ease .15s;\r\n}\r\n\r\n/*\r\n    Assigned to the element used for node select with the mouse (\"lasso\").\r\n*/\r\n.jtk-lasso {\r\n    border: 2px solid rgb(49, 119, 184);\r\n    background-color: WhiteSmoke;\r\n    opacity: 0.5;\r\n    display: none;\r\n    z-index: 20000;\r\n    position: absolute;\r\n}\r\n\r\n/*\r\n    This class is added to the document body on lasso drag start and removed at the end of lasso dragging. Its purpose\r\n    is to switch off text selection on all elements while the user is dragging the lasso.\r\n*/\r\n.jtk-lasso-select-defeat * {\r\n    -webkit-touch-callout: none;\r\n    -webkit-user-select: none;\r\n    -khtml-user-select: none;\r\n    -moz-user-select: none;\r\n    -ms-user-select: none;\r\n    user-select: none;\r\n}\r\n\r\n/**\r\n    Added to the lasso mask when it is operating in 'inverted' mode, ie. the excluded parts of the UI are covered, rather\r\n    than the normal mode in which the selected parts of the UI are covered.\r\n*/\r\n.jtk-lasso-mask {\r\n    position:fixed;\r\n    z-index:20000;\r\n    display:none;\r\n    opacity:0.5;\r\n    background-color: #07234E;\r\n    top:0;\r\n    bottom:0;\r\n    left:0;\r\n    right:0;\r\n}\r\n\r\n/*\r\n    Assigned to some element that has been selected (either via lasso or programmatically).\r\n*/\r\n.jtk-surface-selected-element {\r\n    border: 2px dotted #c7726c !important;\r\n}\r\n\r\n/*\r\n    Assigned to all pan buttons in a surface widget.\r\n*/\r\n.jtk-surface-pan {\r\n    background-color: Azure;\r\n    opacity: 0.4;\r\n    text-align: center;\r\n    cursor: pointer;\r\n    z-index: 2;\r\n    -webkit-transition: background-color 0.15s ease-in;\r\n    -moz-transition: background-color 0.15s ease-in;\r\n    -o-transition: background-color 0.15s ease-in;\r\n    transition: background-color 0.15s ease-in;\r\n}\r\n\r\n/*\r\n    Specific styles for the top and bottom pan buttons.\r\n    Top/bottom are 100% width and 20px high by default\r\n*/\r\n.jtk-surface-pan-top, .jtk-surface-pan-bottom {\r\n    width: 100%;\r\n    height: 20px;\r\n}\r\n\r\n/*\r\n    Hover styles for all pan buttons.\r\n    On hover, change color, background color, font weight and opacity.\r\n*/\r\n.jtk-surface-pan-top:hover, .jtk-surface-pan-bottom:hover, .jtk-surface-pan-left:hover, .jtk-surface-pan-right:hover {\r\n    opacity: 0.6;\r\n    background-color: rgb(49, 119, 184);\r\n    color: white;\r\n    font-weight: bold;\r\n}\r\n\r\n/*\r\n    Specific styles for the left and right pan buttons.\r\n    Left/right pan buttons are 100% height and 20px wide\r\n*/\r\n.jtk-surface-pan-left, .jtk-surface-pan-right {\r\n    width: 20px;\r\n    height: 100%;\r\n    line-height: 40;\r\n}\r\n\r\n\r\n/*\r\n    Assigned to a pan button when the user is pressing it.\r\n*/\r\n.jtk-surface-pan-active, .jtk-surface-pan-active:hover {\r\n    background-color: #f76258;\r\n}\r\n\r\n/* --------------------------------------------------------------------------------------------- */\r\n/* --- MINIVIEW WIDGET ------------------------------------------------------------------------- */\r\n/* --------------------------------------------------------------------------------------------- */\r\n\r\n/*\r\n    Assigned to an element that is acting as a Miniview.\r\n    As with Surface, Miniview elements should have overflow:hidden set to prevent\r\n    libs from scrolling them during drag. This style also provides a default width/height for a miniview,\r\n    which you may wish to override.\r\n*/\r\n.jtk-miniview {\r\n    overflow: hidden !important;\r\n    width: 125px;\r\n    height: 125px;\r\n    position: relative;\r\n    background-color: transparent;\r\n    border: 2px solid #d4d8dc;\r\n    border-radius: 4px;\r\n    opacity: 0.8;\r\n}\r\n\r\n/* \r\n    Assigned to the element that shows the size of the related viewport in a Miniview widget, and which can be dragged to\r\n    move the surface.\r\n*/\r\n.jtk-miniview-panner {\r\n    border: 5px dotted WhiteSmoke;\r\n    opacity: 0.4;\r\n    background-color: rgb(79, 111, 126);\r\n    cursor: move;\r\n    cursor: -moz-grab;\r\n    cursor: -webkit-grab;\r\n}\r\n\r\n/*\r\n    Assigned to the miniview's panner when it is being dragged.\r\n*/\r\n.jtk-miniview-panning {\r\n    cursor: -moz-grabbing;\r\n    cursor: -webkit-grabbing;\r\n}\r\n\r\n/*\r\n    Added to all elements displayed in a miniview.\r\n*/\r\n.jtk-miniview-element {\r\n    background-color: rgb(96, 122, 134);\r\n    position: absolute;\r\n}\r\n\r\n/*\r\n    Added to Group elements displayed in a miniview\r\n*/\r\n.jtk-miniview-group-element {\r\n    background: transparent;\r\n    border: 2px solid rgb(96,122,134);\r\n}\r\n\r\n/*\r\n    Assigned to the collapse/expand miniview button\r\n*/\r\n.jtk-miniview-collapse {\r\n    color: whiteSmoke;\r\n    position: absolute;\r\n    font-size: 18px;\r\n    top: -1px;\r\n    right: 3px;\r\n    cursor: pointer;\r\n    font-weight: bold;\r\n}\r\n\r\n/*\r\n    The '-' symbol when the miniview is expanded\r\n*/\r\n.jtk-miniview-collapse:before {\r\n    content: \"\\2012\";\r\n}\r\n\r\n/*\r\n    Assigned to the miniview element when it is collapsed.\r\n*/\r\n.jtk-miniview-collapsed {\r\n    background-color: #449ea6;\r\n    border-radius: 4px;\r\n    height: 22px;\r\n    margin-right: 0;\r\n    padding: 4px;\r\n    width: 21px;\r\n}\r\n\r\n/*\r\n    Hide all children of the miniview (except the expand button) when it is collapsed so you don't see anything\r\n    poking through under the + icon.\r\n*/\r\n.jtk-miniview-collapsed .jtk-miniview-element, .jtk-miniview-collapsed .jtk-miniview-panner {\r\n    visibility: hidden;\r\n}\r\n\r\n/*\r\n    The '+' symbol when the miniview is collapsed.\r\n*/\r\n.jtk-miniview-collapsed .jtk-miniview-collapse:before {\r\n    content: \"+\";\r\n}\r\n\r\n/*\r\n    Hover state for the collapse/expand icon.\r\n*/\r\n.jtk-miniview-collapse:hover {\r\n    color: #E4F013;\r\n}\r\n\r\n/* ------------------------------------------------------------------------------------------- */\r\n/* --- DIALOGS --------------------------------------------------------------------------------*/\r\n/* ------------------------------------------------------------------------------------------- */\r\n\r\n/*\r\n    This is the element that acts as the dialog underlay - the modal \"mask\". Note the high z-index default\r\n    set here (and note also the overlay style below has a z-index with a value higher by one).\r\n*/\r\n.jtk-dialog-underlay {\r\n    left: 0;\r\n    right: 0;\r\n    top: 0;\r\n    bottom: 0;\r\n    position: fixed;\r\n    z-index: 100000;\r\n    opacity: 0.8;\r\n    background-color: #CCC;\r\n    display: none;\r\n}\r\n\r\n/*\r\n    This is the element that acts as the parent for dialog content.\r\n*/\r\n.jtk-dialog-overlay {\r\n    position: fixed;\r\n    z-index: 100001;\r\n    display: none;\r\n    background-color: white;\r\n    font-family: \"Open Sans\", sans-serif;\r\n    padding: 9px;\r\n    box-shadow: 0 0 5px grey;\r\n    overflow: hidden;\r\n    border-radius: 3px;\r\n}\r\n\r\n.jtk-dialog-overlay-x {\r\n    max-height:0;\r\n    transition: max-height 0.5s ease-in;\r\n    -moz-transition: max-height 0.5s ease-in;\r\n    -ms-transition: max-height 0.5s ease-in;\r\n    -o-transition: max-height 0.5s ease-in;\r\n    -webkit-transition: max-height 0.5s ease-in;\r\n}\r\n\r\n.jtk-dialog-overlay-y {\r\n    max-width:0;\r\n    transition: max-width 0.5s ease-in;\r\n    -moz-transition: max-width 0.5s ease-in;\r\n    -ms-transition: max-width 0.5s ease-in;\r\n    -o-transition: max-width 0.5s ease-in;\r\n    -webkit-transition: max-width 0.5s ease-in;\r\n}\r\n\r\n.jtk-dialog-overlay-top {\r\n    top:20px;\r\n}\r\n\r\n.jtk-dialog-overlay-bottom {\r\n    bottom:20px;\r\n}\r\n\r\n.jtk-dialog-overlay-left {\r\n    left:20px;\r\n}\r\n\r\n.jtk-dialog-overlay-right {\r\n    right:20px;\r\n}\r\n\r\n.jtk-dialog-overlay-x.jtk-dialog-overlay-visible {\r\n    max-height:1000px;\r\n}\r\n\r\n.jtk-dialog-overlay-y.jtk-dialog-overlay-visible {\r\n    max-width:1000px;\r\n}\r\n\r\n/*\r\n    The element containing buttons in a dialog.\r\n*/\r\n.jtk-dialog-buttons {\r\n    text-align: right;\r\n    margin-top: 7px;\r\n}\r\n\r\n/*\r\n    An individual button in a dialog.\r\n*/\r\n.jtk-dialog-button {\r\n    cursor: pointer;\r\n    margin-right: 5px;\r\n    min-width: 56px;\r\n    background-color: white;\r\n    border: 1px solid #ccc;\r\n    border-radius: 3px;\r\n    padding: 4px;\r\n    outline: none;\r\n}\r\n\r\n/*\r\n    Hover style for an individual button in a dialog.\r\n*/\r\n.jtk-dialog-button:hover {\r\n    color: white;\r\n    background-color: #5184a0;\r\n    border-color:white;\r\n}\r\n\r\n/*\r\n    The titlebar of a dialog.\r\n*/\r\n.jtk-dialog-title {\r\n    text-align: left;\r\n    font-size: 14px;\r\n    margin-bottom: 9px;\r\n}\r\n\r\n.jtk-dialog-content {\r\n    font-size:12px;\r\n    text-align:left;\r\n    min-width:250px;\r\n    margin: 0 14px;\r\n}\r\n\r\n.jtk-dialog-content ul {\r\n    width:100%;\r\n    padding-left:0;\r\n}\r\n\r\n.jtk-dialog-content label {\r\n    cursor: pointer;\r\n    font-weight: inherit;\r\n}\r\n\r\n.jtk-dialog-overlay input, .jtk-dialog-overlay textarea {\r\n    background-color: #FFF;\r\n    border: 1px solid #CCC;\r\n    color: #333;\r\n    font-size: 14px;\r\n    font-style: normal;\r\n    outline: none;\r\n    padding: 6px 4px;\r\n    margin-right: 6px;\r\n}\r\n\r\n.jtk-dialog-overlay input:focus, .jtk-dialog-overlay textarea:focus {\r\n    background-color: #f1f5fb;\r\n    border: 1px solid #5184a0;\r\n    color: #333;\r\n    font-size: 14px;\r\n    font-style: normal;\r\n    outline: none;\r\n}\r\n\r\n/* -------------------------------------------------------------------------------------------- */\r\n/* --- DRAWING TOOLS -------------------------------------------------------------------------- */\r\n/* -------------------------------------------------------------------------------------------- */\r\n\r\n/*\r\n    Assigned to the element that is drawn around some other element when a drawing operation is taking place.\r\n*/\r\n.jtk-draw-skeleton {\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    top: 0;\r\n    bottom: 0;\r\n    outline: 2px solid #84acb3;\r\n    opacity: 0.8;\r\n}\r\n\r\n/*\r\n    Assigned to every handle (top left, top right, bottom left, bottom right, center) in a draw skeleton.\r\n*/\r\n.jtk-draw-handle {\r\n    position: absolute;\r\n    width: 7px;\r\n    height: 7px;\r\n    background-color: #84acb3;\r\n}\r\n\r\n/*\r\n    Assigned to the top left handle in a draw skeleton\r\n*/\r\n.jtk-draw-handle-tl {\r\n    left: 0;\r\n    top: 0;\r\n    cursor: nw-resize;\r\n}\r\n\r\n/*\r\n    Assigned to the top right handle in a draw skeleton\r\n*/\r\n.jtk-draw-handle-tr {\r\n    right: 0;\r\n    top: 0;\r\n    cursor: ne-resize;\r\n}\r\n\r\n/*\r\n    Assigned to the bottom left handle in a draw skeleton\r\n*/\r\n.jtk-draw-handle-bl {\r\n    left: 0;\r\n    bottom: 0;\r\n    cursor: sw-resize;\r\n}\r\n\r\n/*\r\n    Assigned to the bottom right handle in a draw skeleton\r\n*/\r\n.jtk-draw-handle-br {\r\n    bottom: 0;\r\n    right: 0;\r\n    cursor: se-resize;\r\n}\r\n\r\n/*\r\n    Assigned to the center handle in a draw skeleton (the handle by which the element may be dragged). This is\r\n    not visible by defaut; enable if you need it.\r\n*/\r\n.jtk-draw-drag {\r\n    display:none;\r\n    position: absolute;\r\n    left: 50%;\r\n    top: 50%;\r\n    margin-left: -10px;\r\n    margin-top: -10px;\r\n    width: 20px;\r\n    height: 20px;\r\n    background-color: #84acb3;\r\n    cursor: move;\r\n}\r\n\r\n/*\r\n    This class is added to the document body on drag resize start and removed at the end of resizing. Its purpose\r\n    is to switch off text selection on all elements while the user is resizing an element.\r\n*/\r\n.jtk-drag-select-defeat * {\r\n    -webkit-touch-callout: none;\r\n    -webkit-user-select: none;\r\n    -khtml-user-select: none;\r\n    -moz-user-select: none;\r\n    -ms-user-select: none;\r\n    user-select: none;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
